import { ComponentProps } from 'react';
import { Link, generatePath, useParams } from 'react-router';

import { routes } from '@fly/shared';
import { BreadcrumbComponent } from '@fly/shared-ui';
import { Link as RadixLink, Skeleton } from '@radix-ui/themes';

import { useGetRepositoryReleaseQuery } from '../../../store/registry.service';

export const ReleaseArtifactsBreadcrumb: BreadcrumbComponent = ({
  isLast,
}: ComponentProps<BreadcrumbComponent>) => {
  const { owner, name, workflowName, runNumber } = useParams<{
    owner: string;
    name: string;
    workflowName: string;
    runNumber: string;
  }>();

  const { data: repositoryWorkflows, isLoading } = useGetRepositoryReleaseQuery(
    {
      owner: owner!,
      name: name!,
      workflowName: workflowName!,
      workflowRunNumber: runNumber!,
    }
  );

  const workflow = repositoryWorkflows?.[0];
  const run = workflow?.releases?.[0];

  const title = (
    <Skeleton loading={isLoading}>
      {run?.title || `${workflowName}-${runNumber}`}
    </Skeleton>
  );

  return isLast ? (
    <RadixLink className='text-fly-general-black'>
      <strong>{title}</strong>
    </RadixLink>
  ) : (
    <RadixLink asChild color='gray'>
      <Link
        className='font-semibold'
        to={generatePath(
          routes.DASHBOARD.REGISTRY.REPOSITORY.RELEASE_ARTIFACTS,
          {
            owner: owner!,
            name: name!,
            workflowName: workflowName!,
            runNumber: runNumber!,
          }
        )}
      >
        {title}
      </Link>
    </RadixLink>
  );
};
